import type { GroupSelectOption } from '@rma/generic/ui/forms/group-select';

export const BedroomsOptions = [
  { label: '1', value: 'one' },
  { label: '2', value: 'two' },
  { label: '3', value: 'three' },
  { label: '4+', value: 'fourPlus' },
] as const satisfies readonly GroupSelectOption[];

export type BedroomsOptionType = (typeof BedroomsOptions)[number]['value'];

export const BedroomsOptionsToFilter = {
  one: 1,
  two: 2,
  three: 3,
  fourPlus: 4,
} as const satisfies Record<BedroomsOptionType, number>;
